import { useCallback } from 'react';

import { BUSINESS_PLAN_TYPES } from 'constants/businessPlan';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getBusinessPlanType } from 'store/useBusinessToolStore/selectors';

import { useBusinessPlanTypeAvailability } from 'hooks/useBusinessPlanTypeAvailability';

import { IBusinessPlanType } from 'interfaces/businessPlan';

export const useEnableSelectTemplateItem = (template: IBusinessPlanType) => {
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);

  const { isAvailable: isTemplateAvailable, limit } = useBusinessPlanTypeAvailability(template);

  const enableSelectTemplateItem = useCallback(() => {
    if (businessPlanType === template) {
      return false;
    }
    if (
      businessPlanType === BUSINESS_PLAN_TYPES.ONE_PAGE ||
      businessPlanType === BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT ||
      ((template === BUSINESS_PLAN_TYPES.ONE_PAGE || template === BUSINESS_PLAN_TYPES.ONE_PAGE_SHORT) && limit === 0)
    ) {
      return isTemplateAvailable;
    }
    return true;
  }, [isTemplateAvailable, template, businessPlanType]);

  return enableSelectTemplateItem;
};
